// extracted by mini-css-extract-plugin
export default {"menu":"index_menu_56pq7","menuList":"index_menuList_IbIRU"};